import { render, staticRenderFns } from "./transbankPM.vue?vue&type=template&id=3c0abe71"
import script from "./transbankPM.vue?vue&type=script&lang=ts"
export * from "./transbankPM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports